import { Avatar, Box } from '@mui/material';
import { useAppSelector } from 'src/redux_store';

export default function UserAvatar({ size = 50 }: { size?: number }) {
  const { me } = useAppSelector((state) => state.myAccountSlice);
  const avatarUrl = me.avatarUrl;
  const firstCharacter = me.name?.charAt(0);

  if (avatarUrl)
    return (
      <Box
        width={size}
        height={size}
        borderRadius={'50%'}
        overflow={'hidden'}
        position={'relative'}
      >
        <img
          src={avatarUrl}
          alt="avatar"
          width={'100%'}
          height={'100%'}
          style={{ objectFit: 'cover', borderRadius: '50%' }}
        />
      </Box>
    );

  if (firstCharacter)
    return <Avatar sx={{ width: size, height: size, fontWeight: 800 }}>{firstCharacter}</Avatar>;

  return <Avatar sx={{ width: size, height: size }} />;
}
